import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-character-counter',
    templateUrl: './character-counter.component.html',
    styleUrls: ['./character-counter.component.scss'],
    standalone: true,
    imports: [],
})
export class CharacterCounterComponent {
    @Input({ required: true }) text: string = '';
    @Input({ required: true }) maxLength: number = 0;
    @Input({ required: false }) placement: 'left' | 'right' = 'right';
}
